module.exports = __webpack_public_path__ + "img/BE0539791736.2211ee47.png";